import { render, staticRenderFns } from "./MsgAnalysis.vue?vue&type=template&id=46623760&"
import script from "./MsgAnalysis.vue?vue&type=script&lang=js&"
export * from "./MsgAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports